module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_summersale_small_en-888554c05098827585a67a3a8729744d.jpg";